<template>
    <datepicker
        inline
        v-model="model"
        v-bind="$attrs"
        v-on="$listeners"
        class="has-text-centered"
        :day-names='[
            $t("dates.days_short.sunday"),
            $t("dates.days_short.monday"),
            $t("dates.days_short.tuesday"),
            $t("dates.days_short.wednesday"),
            $t("dates.days_short.thursday"),
            $t("dates.days_short.friday"),
            $t("dates.days_short.saturday"),
        ]'
        :month-names='[
            $t("dates.months.january"),
            $t("dates.months.february"),
            $t("dates.months.march"),
            $t("dates.months.april"),
            $t("dates.months.may"),
            $t("dates.months.june"),
            $t("dates.months.july"),
            $t("dates.months.august"),
            $t("dates.months.september"),
            $t("dates.months.october"),
            $t("dates.months.november"),
            $t("dates.months.december"),
        ]'
        :unselectable-days-of-week="enableSunday ? [] : [0]"
        :first-day-of-week="1"
        :academic-year-start="academicYearStart"
    />
</template>

<script>
import Datepicker from "./datepicker/Datepicker";

export default Vue.extend({
  components: {
    Datepicker
  },
  props: {
    value: {
      type: Date
    },
    enableSunday: {
      type: Boolean
    },
    academicYearStart: {
      type: Date
    }
  },
  data() {
    return { model: this.value };
  },
  watch: {
    value(value) {
      this.model = value;
    },
    model(value) {
      this.$emit("input", value);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Calendar.vue